import { useState } from 'react';
import { ExpandMore } from '@mui/icons-material';
import { Chip, Menu, MenuItem } from '@mui/material';
import { AdditionalCurrency } from 'common/types/format';
import { GridRowLabelProps } from 'components/Grid/GridRowLabel/GridRowLabel.props';
import {
  useFundExchangeRateContext
} from 'pages/Waterfall/SpreadsheetConfig/FundExchangeRate/FundExchangeRateContext/FundExchangeRateContext';
import { FundExchangeRateRowLabelProps } from './FundExchangeRateRowLabel.props';

export const FundExchangeRateRowLabel = ({ cell, showStandardCurrency }: FundExchangeRateRowLabelProps) => {
  const context = useFundExchangeRateContext();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  if (context) {
    const { currencyList, selectedCurrency, setSelectedCurrency, standardCurrency } = context;

    const handleClick = (event: React.MouseEvent<HTMLDivElement>) => {
      setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
      setAnchorEl(null);
    };

    const handleSelect = (currency: AdditionalCurrency) => {
      setSelectedCurrency(currency);
      handleClose();
    };

    return (
      <>
        <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', width: '100%' }}>
          <Chip
            label={showStandardCurrency ? (standardCurrency ?? selectedCurrency?.sourceCurrency) : selectedCurrency?.sourceCurrency}
            onClick={handleClick}
            onDelete={handleClick}
            size="small"
            deleteIcon={<ExpandMore />}
            variant="outlined"
            clickable
          />
        </div>
        <Menu
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
        >
          {currencyList?.map(currency => (
            <MenuItem
              key={currency.sourceCurrency.toString()}
              onClick={() => handleSelect(currency)}
              selected={currency === selectedCurrency}
            >
              {currency.sourceCurrency}
            </MenuItem>
          ))}
        </Menu>
      </>
    );
  }

  return null;
};

// Wrapper that forces display of the company's standard currency on the chip
export const StandardExchangeRateRowLabel = (props: GridRowLabelProps) => (
  <FundExchangeRateRowLabel {...props} showStandardCurrency/>
);